"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Dialog = _interopRequireDefault(require("material-ui/Dialog"));
var _ToggleSwitch = _interopRequireDefault(require("../common/ToggleSwitch"));
var _ThemeService = require("../common/ThemeService");
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ShareReportCardModal = /*#__PURE__*/function (_React$Component) {
  _inherits(ShareReportCardModal, _React$Component);
  var _super = _createSuper(ShareReportCardModal);
  function ShareReportCardModal() {
    _classCallCheck(this, ShareReportCardModal);
    return _super.apply(this, arguments);
  }
  _createClass(ShareReportCardModal, [{
    key: "render",
    value: function render() {
      var _this = this,
        _React$createElement;
      var themeColor = (0, _ThemeService.getColor)();
      var themeTextColor = (0, _ThemeService.getTextColor)();
      var childComponent = /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-main-div"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-div"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "share-report-card-header"
      }, this.props.i18next.t("lable.shareReportCard")), /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-times close-icon",
        "data-e2e": "close",
        onClick: this.props.handleClose
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-level-div"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-level-sub-div"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: "share-report-card-level-badge",
        "data-e2e": "medalImg",
        src: this.props.medalUrl
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-level-level-data"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "share-report-card-level-level-name"
      }, this.props.i18next.t("lable.skillLevel"), ": ", this.props.level), /*#__PURE__*/_react["default"].createElement("span", {
        className: "share-report-card-level-level-subDetails"
      }, this.props.i18next.t("lable.overallScore"), ": ", this.props.score, "%"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "share-report-card-level-level-subDetails"
      }, this.props.i18next.t("lable.handsPlayed"), ": ", this.props.noOfHands)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-mygame-analysis-div"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "share-report-card-mygame-analysis-header"
      }, /*#__PURE__*/_react["default"].createElement("b", {
        style: {
          color: '#000000',
          fontFamily: 'Roboto',
          letterSpacing: '0.07px',
          lineHeight: '28px'
        }
      }, ' ', this.props.i18next.t("lable.myGameanalysis"), " \xA0", /*#__PURE__*/_react["default"].createElement("span", {
        className: "fa fa-info-circle",
        style: {
          color: 'grey'
        },
        "data-tip": true,
        "data-for": "spin-info"
      })), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
        id: "spin-info",
        place: "right",
        effect: "solid",
        className: "cust-tooltip_1"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "cust_tooltip_content",
        style: {
          paddingLeft: '10px',
          paddingRight: '15px'
        }
      }, this.props.i18next.t("lable.toggelingOffCategoryLock")), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
        className: "cust_tooltip_content",
        style: {
          paddingLeft: '10px',
          paddingRight: '15px'
        }
      }, /*#__PURE__*/_react["default"].createElement("span", null, this.props.i18next.t("lable.analysisDropdown"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-mygame-analysis-sub-div"
      }, this.props.analysisArray.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.category,
          className: "share-report-card-mygame-analysis-item-div"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "share-report-card-mygame-analysis-item"
        }, _this.props.i18next.t("lable." + item.category)), /*#__PURE__*/_react["default"].createElement(_ToggleSwitch["default"], {
          checked: item.enable,
          handleToggleSwith: function handleToggleSwith() {
            return _this.props.handleToggleSwith(item);
          }
        }));
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-mygame-buttons-div"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-mygame-buttons-cancel",
        onClick: this.props.handleClose
      }, /*#__PURE__*/_react["default"].createElement("span", {
        "data-e2e": "cancel"
      }, this.props.i18next.t("lable.cancel"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-report-card-mygame-buttons-active",
        onClick: this.props.onNextClick,
        style: {
          backgroundColor: themeColor,
          color: themeTextColor
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        "data-e2e": "next"
      }, this.props.i18next.t("lable.next")))));
      // const actions = [
      //     <FlatButton
      //       label="Cancel"
      //       primary={true}
      //       onClick={this.handleClose}
      //     />,
      //     <FlatButton
      //       label="Next"
      //       primary={true}
      //     //   disabled= {this.isShareDisabbled()}
      //     //   onClick={this.onShare}
      //     />,
      //   ];
      return window.innerWidth >= 768 ? /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (_React$createElement = {
        contentStyle: {
          width: 300,
          maxWidth: 'none'
        },
        title: this.props.title
        //  actions ={actions}
        // bodyStyle={{ backgroundColor: "white", width:  "511px", height:"622px !important", padding:'20px',borderRadius:'0px 0px  4px 4px' }}
      }, _defineProperty(_React$createElement, "contentStyle", {
        backgroundColor: 'white',
        width: '511px',
        maxHeight: '622px'
      }), _defineProperty(_React$createElement, "bodyStyle", {
        backgroundColor: 'white',
        width: '522px',
        maxHeight: '622px'
      }), _defineProperty(_React$createElement, "modal", true), _defineProperty(_React$createElement, "open", this.props.open), _defineProperty(_React$createElement, "onRequestClose", this.props.handleClose), _defineProperty(_React$createElement, "autoScrollBodyContent", true), _React$createElement), childComponent) : /*#__PURE__*/_react["default"].createElement("div", {
        className: 'mg-modal centre view-share-modal-div ' + (this.props.open ? 'displayBlock' : 'displayNone')
      }, childComponent);
    }
  }]);
  return ShareReportCardModal;
}(_react["default"].Component);
var _default = ShareReportCardModal;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/ShareReportCardModal.js
 ** module id = 2399
 ** module chunks = 0
 **/